import "./projet.scss";
import $ from 'jquery';




       //Ajoute la class current-menu-item au Menu Projets quand on se trouve dans un single-projet
       if($('article').hasClass('projet')){
           //confirm('Page projet!');
           var  menuProjetString = $('#main-menu li.menu-item')[8];
           console.log(menuProjetString);
           $('.menu').find(menuProjetString).toggleClass('current-menu-item');
       }





